<template>
  <div ref="$el" class="flex flex-col">
    <div v-if="showTitle" class="text-base md:text-lg font-semibold text-black">
      <slot name="title" />
    </div>
    <div v-if="showSubtitle" class="text-foreground-neutral-secondary mt-2">
      <slot name="subtitle" />
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  as?: string | Component
  showTitle?: boolean
  showSubtitle?: boolean
}

const slots = defineSlots<{
  title: () => any
  subtitle: () => any
}>()

withDefaults(defineProps<Props>(), {
  showTitle: true,
  showSubtitle: true,
})
</script>
